import { alertConstants } from '../_constants';
import { toast } from 'react-toastify';
import constantMsg from '../_helpers/constantMsg';
import { getAlertMessage } from '../_helpers/alertMessage';


export const alertActions = {
    success,
    error,
    clear,
    warning
};

function success(message) { 
    message = getAlertMessage(message, 'Action completed successfully.');
    toast.success(message)
    return { type: alertConstants.SUCCESS, message: message };
}

function error(message) {
    message = getAlertMessage(message, constantMsg.FAILED_MSG);
    toast.error(message)
    return { type: alertConstants.ERROR, message: message };
}

function warning(message) {
    message = getAlertMessage(message, 'Please review your information before continuing.');
    toast.warning(message, {
      style: { color: "black" }, // Change text color
      className: "custom-toast", // Optional: Add custom class for further styling
      bodyClassName: "custom-toast-body" // Optional: For body-specific styling
    });
    return { type: alertConstants.WARNING, message: message };
  }

function clear() {
    return { type: alertConstants.CLEAR };
}
